<template>
  <div>
    <transaction-tabs type="imprest"></transaction-tabs>
    <v-card class="white rounded-lg">
      <v-card-title class="secondary--text">{{ title }}</v-card-title>
      <v-card-text>
        <m-datatable
            :headers="headers"
            :apiUrl="url"
            :filters.sync="filters"
            @dblclick:row="(e, row) => $router.push(to(row.item))"
            ref="datatable"
        >
          <template #item.detail="{ item }">
            <detail-link :to="to(item)"/>
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
import TransactionTabs from "@/views/panel/transaction/TransactionTabs";

export default {
  name: "TransactionsList",
  components: {TransactionTabs},
  data() {
    return {
      filters: {},
      url: "reports/lists/imprestSettlements",
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('لیست تسویه های تنخواه')
    },
    headers() {
      let headers = [
        {
          text: "شماره",
          value: "code",
        },
        {
          text: "تنخواه گردان",
          value: "account.name",
        },
        {
          text: "تاریخ",
          value: "date",
          type: 'date',
        },
        {
          text: "شرح",
          value: "explanation",
        },
        {
          text: "مبلغ تسویه",
          value: "sanad.bes",
          type: "numeric",
        },
        {
          text: "جزئیات",
          value: "detail",
          sortable: false,
          filterable: false,
        }
      ];

      return headers;
    },
  },
  watch: {
    $route() {
      this.$refs.datatable.getDataFromApi();
    },
  },
  methods: {
    to(item) {
      return {
        name: "ImprestSettlementForm",
        params: {
          id: item.id,
        },
      };

    },
  },
};
</script>

<style scoped lang="scss"></style>
